<template>
    <div>
      <!-- 头部 -->
      <top></top>
      <div class="main">
        <navMenu :active="active"></navMenu>
        <div class="content">
          <div class="go-back"  @click="goBack">返回</div>
            <div class="txt_box">请确认您所预定的参展商代表证是为责公司在展览会期间展台工作人员所制作，所有参展商代表证将事先制作完成，并在<br>2025年9月4日-5日到展览会现场报到处领取。<br>您一共可以申请{{badge_max}}张展商胸卡<span style="color: red;">当前剩余{{allow_badge}}</span>，如胸卡数量不足，请联系主办方增加数量，会收取部分费用。<br>联系方式:010-68512208，010-68511814 电子邮箱:<span style="color: #1677ff;">expo@bceia.cn</span></div>
          <div class="header_box">
              <div style="width: 100%;">
                <div class="main-title">展商胸卡</div>
                  <!-- <div class="main-sub">
                    请在此页面内为您的单位提供详细的展示资料，以便于专业买家在becia展商平台上查询与筛选时更好的展现。
                  </div> -->
              </div>
              <div class="right_box">
                  <div class="times">提交截止日期：{{ detail.deadline }}</div>
                  <div class="create-btn" @click="addposition">
                      申请参展胸卡
                  </div>
              </div>
          </div>
          <!-- 列表 -->
          <div class="invitation-table">
            <el-table
              v-if="tableData.length>0"
              class="my-table"
              :data="tableData"
              stripe
              v-loading="loading"
              style="width: 100%; min-height: 600px"
              :header-cell-style="{
                textAlign: 'center',
                color: '#3A3A3C',
                fontWeight: 'normal',
                fontSize: '14px',
              }"
              :cell-style="{ textAlign: 'center',fontSize: '14px', }"
            >
              <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
              <el-table-column
                prop="id"
                label="胸卡id"
                width="100"
                sortable
              ></el-table-column>
              <!-- <el-table-column label="照片">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img"
                    style="width: 69px; height: 69px; display: block;margin: 0 auto;"
                  ></el-image>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="name_cn"
                  width="200"
                label="楣板字中文"
              ></el-table-column>
              <el-table-column
                prop="name_en"
                  width="200"
                label="楣板字英文"
              ></el-table-column>
              <!-- <el-table-column
                label="产品分类"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.product_type[0].tname ? scope.row.product_type[0].tname : '-'}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.status ? '上架' : '下架'}}</div>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="name"
                label="姓名"
               
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="手机"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="position"
                label="职务"
               
              ></el-table-column>
              <el-table-column
                prop="update_time"
                label="最后修改时间"
                sortable
                width="200"
              ></el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <span class="check-btn" @click="edit(scope.row,1)"
                    >编辑</span
                  >
                  <span class="check-btn" @click="edit(scope.row,2)"
                    >查看</span
                  >
                  <span class="check-btn check-del" @click="del(scope.$index, scope.row)"
                    >删除</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <nodata v-else></nodata>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pagesize"
              layout="total, prev, pager, next, jumper"
              :total="totals"
            >
            </el-pagination>
          </div>
        </div>
     
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
       
        :before-close="handleClose">
         <div>
            <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-position="right"
            label-width="100px"
            >
           
            <el-form-item label="姓名：" >
               <el-input  :disabled="title=='查看胸卡'?true:false" placeholder="请填写姓名" v-model="ruleForm.name"></el-input>
            </el-form-item>
     
          <el-form-item label="手机：" prop="phone">
            <el-input   :disabled="title=='查看胸卡'?true:false" placeholder="请填写手机" v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="职务：">
            <el-input  :disabled="title=='查看胸卡'?true:false" placeholder="请填写职务" v-model="ruleForm.position"></el-input>
          </el-form-item>
          <el-form-item label="证件号码：">
            <el-input type="number"  :disabled="title=='查看胸卡'?true:false" placeholder="请填写证件号码" v-model="ruleForm.idcard_number"></el-input>
          </el-form-item>
          </el-form>
         </div>
        <span slot="footer" class="dialog-footer" v-if="title!=='查看胸卡'">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit('ruleForm')">确 定</el-button>
        </span>
        </el-dialog>
    </div>
    
  </template>
  
  <script>
  import { badgeList, delBadge,addBadge,editBadge } from "@/api/api";
  import top from "../components/top.vue"; //头部
  import navMenu from "../components/navMenu.vue"; //左侧步骤条
  import nodata from "../components/nodata.vue"; //头部
  export default {
    components: { top, navMenu,nodata },
    name: "nameTag",
    data() {
      return {
        ruleForm:{
            name:"",
            phone:"",
            position:"",
            idcard_number:""
        },
          rules:{
              phone: [
                  { required: true, message: "请填写", trigger: "blur" },
                  {
                      pattern: /^1[3-9]\d{9}$/,
                      message: "手机号码格式不正确",
                      trigger: "blur",
                  },
              ],
          },
        status:'0',
        loading: false,
        active: 1,
        position: "",
        totals: 0,
        tableData: [],
        currentPage: 1,
        page: 1,
        pagesize: 10,
        typeList: [],
        dialogVisible:false,
        title:'',
        mark:'',
          detail:{},
          allow_badge:'',
          badge_max:''
      };
    },
    mounted() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "/standPrepare";
      });
      this.detail=stepMenuList[index].children[2];
      console.log(stepMenuList[index],"stepMenuList[index]")
      this.active = index;
      this.page = 1;
      this.mark=this.$route.query.mark;
      // 获取列表
      this.getList(this.page, this.position);
    },
    created() {},
    methods: {
        dialogSubmit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = this.ruleForm;
                    data.mark = this.mark
                    if (data.badge_long_id) {//编辑
                        this.editBadge(data)
                    } else {// 新增
                        this.addBadge(data)
                    }
                }
            })

        },
          //新增
          addBadge(data){
            addBadge(data).then((res) => {
            console.log(res.data, "===新增数据");
            if (res.code == 1) {
                this.$message.success(res.msg);
               this.dialogVisible=false;
               this.getList(this.page, this.position);
            } else {
              this.$message.warning(res.message);
            }
          }).catch((err) => {
            console.log(err)
          });
      },
       //编辑
       editBadge(data){
        editBadge(data).then((res) => {
            console.log(res.data, "===修改数据");
            if (res.code == 1) {
                this.$message.success(res.msg);
              this.dialogVisible=false;
              this.getList(this.page, this.position);
            } else {
              this.$message.warning(res.msg);
            }
          })
          .catch((err) => {
            console.log(err)
          });
      },
    handleClose(){
       this.dialogVisible=false;
    },
     // 添加职位
     addposition(){
        this.ruleForm.name=""
        this.ruleForm.phone=""
        this.ruleForm.position=""
        this.ruleForm.idcard_number=""
        this.ruleForm.badge_long_id=""
        this.dialogVisible=true;
        this.title="添加胸卡"
     },
      //搜索
      search(){
        this.page = 1;
        this.getList(this.page, this.position);
      },
      reset(){
        this.page = 1;
        this.position="";
        this.getList(this.page, this.position);
      },
      //获取列表
      getList(page, position) {
        let data = this.$qs.stringify({
          page_size: this.pagesize,
          page_no: page,
          position,
        });
        this.loading = true;
        badgeList(data).then((res) => {
            if (res.code == 1) {
              this.loading = false;
              let { data } = res;
              this.allow_badge=data.allow_badge;
                this.badge_max=data.badge_max;
              let arr = data.lists;
              this.tableData = arr;
              this.totals = data.count;
            }else{
              this.$message.warning(res.data)
            }
          })
          .catch((err) => {
            if(err.response.code != 401){
              this.$message.warning(err.response.data)
            }
          });
      },
    
      // 返回
      goBack() {
        this.$router.back();
      },
      // 编辑
      edit(row,type){
         if(type==1){
            this.title="编辑胸卡"
         }else{
            this.title="查看胸卡"
         }
         this.dialogVisible=true;
         this.ruleForm.name=row.name;
         this.ruleForm.phone=row.phone;
         this.ruleForm.position=row.position;
         this.ruleForm.idcard_number=row.idcard_number;
         this.ruleForm.badge_long_id=row.badge_long_id;

         
      },// 删除
      del(index, row){
        this.$alert(`确定要删除吗？`, '', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action, '==action')
              if(action == 'confirm'){
                delBadge({badge_long_id: row.badge_long_id})
                  .then(res => {
                    if(res.code == 1){
                      this.tableData.splice(index, 1);
                      this.totals = this.totals - 1;
                      this.$message.success(res.data.msg);
                    
                    }
                  })
                  .catch(err => {
                    console.log(err, '===err')
                  })
              }
            }
          });
      },
      // 分页相关
      handleCurrentChange(val) {
        this.page = val;
        this.getList(this.page, this.position)
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
      .times{
          width: 300px;
          color: red;
      }
      .right_box{

          display: flex;
          align-items: center;
      }
   .txt_box{
      line-height: 30px;
       margin-top: 25px;
   }
  .pagination_box{
    text-align: right;
    margin-top: 50px;
  }
  .goods_name{
    line-height: 20px;
    font-size:16px;
    font-weight: 600;
    color: #000;
  }
  .tname{
    font-size:14px;
    font-weight: 400;
    color: #000;
    margin-top: 15px;
  }
  .inputtime{
    font-size:12px;
    font-weight: 400;
    color: #969696;
    margin-top: 10px;
    line-height: 18px;
  }
  .p_footer{
    display: flex;
   
    .p_item_footer{
      width: 50%;
      height: 64px;
      line-height: 64px;
      text-align: center;
     
    }
    .p_item_footer:nth-child(1){
      border-right: 2px solid #eee;
    }
    
  }
  .header_box{
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px
  }
   .create-btn {
      width: 148px;
      height: 42px;
      color: #fff;
      font-size: 19px;
      font-weight: 500;
      cursor: pointer;
      line-height: 42px;
      text-align: center;
      background: #1677ff;
      border-radius: 4px;
      &:hover{
        text-decoration: underline;
      }
    }
  .content-type {
    padding-bottom: 35px;
    .main-title {
      width: 100%;
      margin-top: 40px;
    }
  }
  .p_list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    // background: #fff;
    // border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
  .p_item{
       width: -webkit-calc((100% - 20px * 4)/ 4);
        width: calc((100% - 20px * 4) / 4);
        margin: 0 20px 20px 0;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  .p_item_top{
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .select_box{
      width: 80px;
    }
  }
  .p_item_scoend{
    margin-top: 10px;
    padding: 0 15px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #eee;
    img{
      width: 100px;
      height: 100px;
      border-radius: 10px;
      margin-right: 20px;
    }
  }
  .search-wrap {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    margin-top: 50px;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
   
    margin-bottom: 20px;
    .search-input {
      align-items: center;
    }
    .search-input .search-btn {
      width: 130px;
      height: 42px;
     
      cursor: pointer;
      font-size: 19px;
      margin-right: 11px;
      line-height: 42px;
      text-align: center;
      // background: #2c2c2e;
      border-radius: 4px;
      &:hover{
        text-decoration: underline;
      }
    }
    .search{
      background: #008DFF;
      color: #fff;
    }
    .reset{
      color: #2690E6;
      border: 1px solid #008DFF;
      margin-left: 11px;
    }
   
  }
  .invitation-table{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 30px !important;
    padding-top: 0 !important;
    border-top: 0 none !important;
  }
  </style>
  <style lang="scss">
  .search-wrap {
    .search-input {
      .el-input {
        font-size: 14px;
        width: 40%;
      }
      .el-input__inner {
        height: 42px;
        line-height: 42px;
        border-radius: 4px;
      }
    }
  }
  .invitation-table .el-pagination {
    margin-top: 30px;
    text-align: center;
    .el-pager li,
    .el-pagination__total {
      font-size: 14px;
    }
    .el-pagination__jump {
      font-size: 14px;
    }
  }
  .my-table {
    color: #888;
    font-size: 18px;
    // margin-top: 30px;
  }
  .my-table tbody td,
  .my-table tbody th {
    height: 70px;
    padding: 5px 0;
    box-sizing: border-box;
  }
  .my-table tbody th,
  .my-table tbody tr {
    background: #f2f6fb;
  }
  .my-table tbody tr.is-new {
    color: #0e0e0e;
  }
  .check-btn {
    color: #1677ff;
    cursor: pointer;
    margin-left: 20px;
  }
  .check-btn:hover{
    text-decoration: underline;
  }
  .check-del {
    color: #ff4d4f;
   
  }
  .my-table tbody tr td .check-btn {
    color: #1677ff;
    cursor: pointer;
  }
  .my-table tbody tr td .check-btn:hover{
    text-decoration: underline;
  }
  .my-table tbody tr td .check-btn.check-del {
    color: #ff4d4f;

  }
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #fff;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 0 none;
  }
  /* 表格最外层边框-底部边框 */
  .el-table--border::after,
  .el-table--group::after {
    width: 0;
  }
  .my-table::before {
    width: 0;
  }
  .my-table tbody tr td:first-child {
    border-radius: 10px 0 0 10px;
  }
  .my-table tbody tr td:last-child {
    border-radius: 0 10px 10px 0;
  }
  @media only screen and (max-width: 1366px) {
    .p_list{
      width: 100% !important;
    }
    .p_item{
       width: -webkit-calc((100% - 20px * 3)/ 3) !important;
        width: calc((100% - 20px * 3) / 3)!important;
        margin: 0 20px 20px 0 !important;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  }
  @media only screen and (max-width: 1280px) {
    .p_list{
    width: 100% !important;
   
  }
    .p_item{
    
       width: -webkit-calc((100% - 15px * 2)/ 2) !important;
        width: calc((100% - 15px * 2) / 2)!important;
        margin: 0 15px 15px 0 !important;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  }
  @media only screen and (max-width: 1200px) {
    .p_list{
    width: 100% !important;
   
  }
    .p_item{
  
       width: -webkit-calc((100% - 15px * 2)/ 2) !important;
        width: calc((100% - 15px * 2) / 2)!important;
      //   margin: 0 15px 15px 0 !important;
        background: #fff;
        border-radius: 8px;
        padding: 20px 0 0;
        box-sizing: border-box;
  }
  }
  @media only screen and (max-width: 767px) {
    .invitation-table{
      width: 92%;
    }
    .el-pagination {
      padding: 2px 23px !important;
    }
    .p_item_footer{
      height: 54px!important;
      line-height: 54px!important;
      font-size:14px!important;
    }
    .tname{
      margin-top: 10px !important;
    }
    .inputtime{
      margin-top: 10px !important;
    }
    .p_item_scoend img{
      width: 80px !important;
      height: 81px !important;
      margin-right: 15px !important;
  }
    .create-btn{
      width: 120px !important;
      height: 40px !important;
      font-size: 15px !important;
    }
    .search-wrap .search-input .search-btn{
      width: 130px!important;
      height: 40px!important;
      font-size: 15px !important;
    }
    .content{
      padding: 30px 0 130px 0;
    }
    .p_item{
      width: 100% !important;
      margin: 0 auto 20px !important;
    }
  .p_list{
    width: 100% !important;
    margin-left: 0 !important;
    display: inline-block !important;
   
  }
  .search-wrap{
    width: 100% !important;
    margin:0 auto !important;
  }
  .search-input{
  flex-wrap: wrap;
  }
  .el-input__inner{
    // width: 90% !important;
    margin: 20px 0;
  }
  .main-sub{
    width: 100%;
    padding-bottom: 8px !important;
  }
  .header_box{
   
    padding-bottom: 50px !important;
  }
  .create-btn{
    margin-bottom: 20px !important;
    position: absolute;
    right: 24px;
    bottom: 0;
  }
  .search-wrap .search-input .el-input{
    width: 100% !important;
  }
  
  }
  </style>
  <style>
   .el-dialog{
      width: 35%;
    }
  @media only screen and (max-width: 767px) {
    .el-pagination {
      padding: 2px 23px !important;
    }
    .el-dialog{
      width: 100%;
    }
    .el-message-box{
      width: 350px !important;
    }
  }
  </style>